import GsButtonIcon from "./gs-button-icon.vue"
const component = {
  install: (Vue) => {
    Vue.component('GsButtonIcon', GsButtonIcon)
  }
}
export default component